import { defineMessages } from 'react-intl';

/**
 * Intl messages for the Allowance step (step 4) chrome — the page heading and
 * the two tab labels. Per-meter copy on this step lives in the content
 * registry (`allowanceStep.nextCta`); these strings are meter-agnostic.
 */
export const messages = defineMessages({
	pageTitle: {
		id: 'ubp.calculator.allowance.pageTitle',
		defaultMessage: 'Explore how Atlassian collections and apps cover your usage needs',
	},
	tabCollections: {
		id: 'ubp.calculator.allowance.tabCollections',
		defaultMessage: 'Atlassian Collections',
	},
	tabApps: {
		id: 'ubp.calculator.allowance.tabApps',
		defaultMessage: 'Atlassian apps',
	},
});
